import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as WarningImage } from '../../../assets/warning.svg';
import { useTheme } from '@mui/material/styles';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, type, identifierName }: any) => {
  const theme = useTheme();
  const colors = theme.palette;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: `${colors.modal.background} !important`,
          color: `${colors.modal.text} !important`,
          width: '500px',
          borderRadius: '4px',
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: `${colors.modal.titleBg} !important`,
          color: `${colors.modal.title} !important`,
          gap: 2,
          p: '16px !important',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>
          Deleting {type}: <span>{identifierName}</span>
        </span>
        <IconButton onClick={onClose} sx={{ color: `${colors.modal.title} !important` }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-start"
          gap={1}
          sx={{ marginTop: '20px', p: '16px !important' }}
        >
          <WarningImage style={{ width: 40, height: 40, marginRight: 2 }} />
          <Box textAlign="left">
            <Typography variant="widgetTitle">Are you sure to delete this {type}?</Typography>
            <Typography variant="body2" sx={{ opacity: 1 }}>
              Once confirmed, the action can't be undone.
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: '0px 16px 16px 16px' }}>
        <Button
          onClick={onClose}
          variant="pepwiseOutline"
          sx={{ color: `${colors.buttons.primary.color} !important` }}
        >
          NO, I WANT IT!
        </Button>
        <Button onClick={onConfirm} variant="pepwiseError">
          DELETE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
